import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import ManagerApi from "../../api/manager.api";
import SaveBtn from "../../component/atoms/button/saveBtn";
import MainInput from "../../component/atoms/input/mainInput";
import Radio from "../../component/atoms/input/radio";
import DetailPage from "../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../component/atoms/layout/mainLayout";
import DetailFormText from "../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../component/atoms/text/detail/detailPageTitle";
import PretendardText from "../../component/atoms/text/pretendardText";
import GoBack from "../../component/molecules/goBack";
import Header from "../../component/organisms/header";
import Sidebar from "../../component/organisms/sidebar";
import Modal from "../../component/templates/Modal";
import { sideMenu } from "../../constants/sidebarMenu";
import { isNull } from "../../util/check";
import { errorHandler } from "../../util/errorHandler";
import { modalMsg } from "../../util/modalMsg";
import { regExpression } from "../../util/regExpresstion";
import { toastMsg } from "../../util/toastMsg";
import AuthorityCheckbox from "./_component/authorityCheckbox";

function RootEdit(props) {
  // import
  const navigate = useNavigate();
  let { id } = useParams();

  // ----- 정보 가져오기
  const [managerInfo, setManagerInfo] = useState({
    name: "",
    email: "",
    password: "",
    passwordCheck: "",
    rootFlag: "",
    accessMenu: [],
    passwordChangeFlag: false,
  });

  const getManagerInfo = async () => {
    try {
      const response = (await ManagerApi.getById(id)).data.data.content;

      setManagerInfo({
        name: response.name,
        email: response.email,
        rootFlag: response.rootFlag,
        accessMenu: response.accessMenu ? response.accessMenu : [],
        passwordChangeFlag: false,
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getManagerInfo();
  }, []);

  // ----- 비밀번호 변경
  const [pwEdit, setPwEdit] = useState(false);

  // 비밀번호 체크
  const pwErr = useMemo(() => {
    if (
      !isNull(managerInfo.password) &&
      !regExpression.password.test(managerInfo.password)
    ) {
      return true;
    }
    return false;
  }, [managerInfo.password]);

  // 비밀번호 확인 체크
  const pwCheckErr = useMemo(() => {
    if (
      !isNull(managerInfo.password) &&
      !isNull(managerInfo.passwordCheck) &&
      managerInfo.password !== managerInfo.passwordCheck
    ) {
      return true;
    }
    return false;
  }, [managerInfo.password, managerInfo.passwordCheck]);

  // 저장하기
  const [saveModalOpen, setSaveModalOpen] = useState(false);
  const saveFunc = async () => {
    try {
      if (isNull(managerInfo.name.trim())) {
        setSaveModalOpen(false);
        return toast("이름을 입력해주세요.");
      }
      if (pwEdit) {
        if (isNull(managerInfo.password)) {
          setSaveModalOpen(false);
          return toast("비밀번호를 입력해주세요");
        }
        if (isNull(managerInfo.passwordCheck)) {
          setSaveModalOpen(false);
          return toast("비밀번호를 입력해주세요");
        }
        if (pwErr) {
          setSaveModalOpen(false);
          return toast("비밀번호를 올바르게 입력해주세요");
        }
        if (pwCheckErr) {
          setSaveModalOpen(false);
          return toast("비밀번호가 일치하지 않습니다");
        }
      }

      const requestDto = {
        email: managerInfo.email,
        name: managerInfo.name.trim(),
        rootFlag: managerInfo.rootFlag,
        accessMenu: [...new Set(managerInfo.accessMenu)],
        passwordChangeFlag: managerInfo.passwordChangeFlag,
        password: managerInfo.password,
      };

      await ManagerApi.update(id, requestDto);
      toast(toastMsg.update);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage style={{ paddingBottom: "83px" }}>
            <DetailPageTitle>수정하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>이름*</DetailFormTitle>
                <MainInput
                  style={{ width: "338px" }}
                  type={"text"}
                  placeholder={"이름을 입력해주세요"}
                  value={managerInfo.name}
                  onChange={(e) => {
                    setManagerInfo({ ...managerInfo, name: e.target.value });
                  }}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>이메일</DetailFormTitle>
                <DetailFormText>{managerInfo.email}</DetailFormText>
              </DetailPageForm>
              {pwEdit ? (
                <>
                  <DetailPageForm>
                    <DetailFormTitle>비밀번호*</DetailFormTitle>
                    <MainInput
                      style={{ width: "338px" }}
                      type={"password"}
                      placeholder={"새로운 비밀번호를 입력해 주세요."}
                      helperText={
                        "영문/숫자/특수문자 중 2가지 이상 포함, 8자 ~ 16자"
                      }
                      onError={pwErr}
                      value={managerInfo.password}
                      onChange={(e) => {
                        setManagerInfo({
                          ...managerInfo,
                          password: e.target.value,
                        });
                      }}
                    />
                  </DetailPageForm>
                  <DetailPageForm>
                    <DetailFormTitle>비밀번호 재입력*</DetailFormTitle>
                    <MainInput
                      style={{ width: "338px" }}
                      type={"password"}
                      placeholder={"새로운 비밀번호를 한 번 더 입력해 주세요."}
                      helperText={"비밀번호가 일치하지 않습니다"}
                      onError={pwCheckErr}
                      value={managerInfo.passwordCheck}
                      onChange={(e) => {
                        setManagerInfo({
                          ...managerInfo,
                          passwordCheck: e.target.value,
                        });
                      }}
                    />
                  </DetailPageForm>
                </>
              ) : (
                <DetailPageForm>
                  <DetailFormTitle>비밀번호</DetailFormTitle>
                  <PwEditBtn
                    onClick={() => {
                      setManagerInfo({
                        ...managerInfo,
                        passwordChangeFlag: true,
                      });
                      setPwEdit(true);
                    }}
                  >
                    비밀번호 변경
                  </PwEditBtn>
                </DetailPageForm>
              )}

              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>관리자 유형*</DetailFormTitle>
                <div style={{ display: "flex", gap: "19px" }}>
                  <Radio
                    id={"ROOT"}
                    valueText={"ROOT"}
                    name={"author"}
                    checked={managerInfo.rootFlag}
                    onChange={() => {
                      setManagerInfo({
                        ...managerInfo,
                        rootFlag: true,
                        accessMenu: [],
                      });
                    }}
                  />
                  <Radio
                    id={"ADMIN"}
                    valueText={"ADMIN"}
                    name={"author"}
                    checked={!managerInfo.rootFlag}
                    onChange={() => {
                      setManagerInfo({
                        ...managerInfo,
                        rootFlag: false,
                        accessMenu: [],
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <PretendardText
                style={{
                  color: "#FF4975",
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "22.4px",
                  letterSpacing: "-0.408px",
                }}
              >
                *ROOT일 경우 아래 접근권한 설정에 관계없이 모든 메뉴 접근이
                가능합니다.
              </PretendardText>
              <DetailPageForm
                style={{ alignItems: "flex-start", marginBottom: "79px" }}
              >
                <DetailFormTitle>접근권한*</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "22px",
                  }}
                >
                  {sideMenu.map((item, index) => {
                    if (index === 0) return;
                    return (
                      <div key={index}>
                        <CheckboxListTitle>{item.title}</CheckboxListTitle>

                        <div style={{ display: "flex", gap: "20px" }}>
                          {item.subMenus.length > 0 ? (
                            <>
                              {item.subMenus?.map((item02, index02) => {
                                return (
                                  <AuthorityCheckbox
                                    key={index02}
                                    checked={
                                      managerInfo.accessMenu.includes(
                                        item02.link
                                      ) || managerInfo.rootFlag
                                    }
                                    onChange={(checked) => {
                                      if (checked) {
                                        managerInfo.accessMenu.push(
                                          item02.link
                                        );
                                      } else {
                                        managerInfo.accessMenu =
                                          managerInfo.accessMenu.filter(
                                            (item) => item !== item02.link
                                          );
                                      }
                                      setManagerInfo({ ...managerInfo });
                                    }}
                                    text={item02.title}
                                    disabled={managerInfo.rootFlag}
                                  />
                                );
                              })}
                            </>
                          ) : (
                            <AuthorityCheckbox
                              checked={
                                managerInfo.accessMenu.includes(item.link) ||
                                managerInfo.rootFlag
                              }
                              onChange={(checked) => {
                                if (checked) {
                                  managerInfo.accessMenu.push(item.link);
                                } else {
                                  managerInfo.accessMenu =
                                    managerInfo.accessMenu.filter(
                                      (item) => item !== item.link
                                    );
                                }
                                setManagerInfo({ ...managerInfo });
                              }}
                              text={item.title}
                              disabled={managerInfo.rootFlag}
                            />
                          )}
                        </div>
                      </div>
                    );
                  })}

                  {/* <div>
                    <CheckboxListTitle>강의 관리</CheckboxListTitle>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <AuthorityCheckbox
                        checked={
                          managerInfo.accessMenu.includes(route.exercise) ||
                          managerInfo.rootFlag
                        }
                        onChange={(checked) => {
                          if (checked) {
                            managerInfo.accessMenu.push(route.exercise);
                          } else {
                            managerInfo.accessMenu =
                              managerInfo.accessMenu.filter(
                                (item) => item !== route.exercise
                              );
                          }
                          setManagerInfo({ ...managerInfo });
                        }}
                        text={"재활운동 콘텐츠 관리"}
                        disabled={managerInfo.rootFlag}
                      />
                    </div>
                  </div>

                  <div>
                    <CheckboxListTitle>서비스 관리</CheckboxListTitle>
                    <div
                      style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}
                    >
                      <AuthorityCheckbox
                        checked={
                          managerInfo.accessMenu.includes(
                            route.service_alarm
                          ) || managerInfo.rootFlag
                        }
                        onChange={(checked) => {
                          if (checked) {
                            managerInfo.accessMenu.push(route.service_alarm);
                          } else {
                            managerInfo.accessMenu =
                              managerInfo.accessMenu.filter(
                                (item) => item !== route.service_alarm
                              );
                          }
                          setManagerInfo({ ...managerInfo });
                        }}
                        text={"알림 관리"}
                        disabled={managerInfo.rootFlag}
                      />

                      <AuthorityCheckbox
                        checked={
                          managerInfo.accessMenu.includes(route.cs_notice) ||
                          managerInfo.rootFlag
                        }
                        onChange={(checked) => {
                          if (checked) {
                            managerInfo.accessMenu.push(route.cs_notice);
                          } else {
                            managerInfo.accessMenu =
                              managerInfo.accessMenu.filter(
                                (item) => item !== route.cs_notice
                              );
                          }
                          setManagerInfo({ ...managerInfo });
                        }}
                        text={"공지사항 관리"}
                        disabled={managerInfo.rootFlag}
                      />

                      <AuthorityCheckbox
                        checked={
                          managerInfo.accessMenu.includes(
                            route.service_popup
                          ) || managerInfo.rootFlag
                        }
                        onChange={(checked) => {
                          if (checked) {
                            managerInfo.accessMenu.push(route.service_popup);
                          } else {
                            managerInfo.accessMenu =
                              managerInfo.accessMenu.filter(
                                (item) => item !== route.service_popup
                              );
                          }
                          setManagerInfo({ ...managerInfo });
                        }}
                        text={"팝업 관리"}
                        disabled={managerInfo.rootFlag}
                      />

                      <AuthorityCheckbox
                        checked={
                          managerInfo.accessMenu.includes(
                            route.service_terms
                          ) || managerInfo.rootFlag
                        }
                        onChange={(checked) => {
                          if (checked) {
                            managerInfo.accessMenu.push(route.service_terms);
                          } else {
                            managerInfo.accessMenu =
                              managerInfo.accessMenu.filter(
                                (item) => item !== route.service_terms
                              );
                          }
                          setManagerInfo({ ...managerInfo });
                        }}
                        text={"약관 관리"}
                        disabled={managerInfo.rootFlag}
                      />
                      <AuthorityCheckbox
                        checked={
                          managerInfo.accessMenu.includes(
                            route.service_basic
                          ) || managerInfo.rootFlag
                        }
                        onChange={(checked) => {
                          if (checked) {
                            managerInfo.accessMenu.push(route.service_basic);
                          } else {
                            managerInfo.accessMenu =
                              managerInfo.accessMenu.filter(
                                (item) => item !== route.service_basic
                              );
                          }
                          setManagerInfo({ ...managerInfo });
                        }}
                        text={"기본 정보 관리"}
                        disabled={managerInfo.rootFlag}
                      />
                    </div>
                  </div>
                  <div>
                    <CheckboxListTitle>관리자회원 관리</CheckboxListTitle>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <AuthorityCheckbox
                        checked={
                          managerInfo.accessMenu.includes(route.manager) ||
                          managerInfo.rootFlag
                        }
                        onChange={(checked) => {
                          if (checked) {
                            managerInfo.accessMenu.push(route.manager);
                          } else {
                            managerInfo.accessMenu =
                              managerInfo.accessMenu.filter(
                                (item) => item !== route.manager
                              );
                          }
                          setManagerInfo({ ...managerInfo });
                        }}
                        text={"관리자회원 관리"}
                        disabled={managerInfo.rootFlag}
                      />
                    </div>
                  </div> */}
                </div>
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  setSaveModalOpen(true);
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default RootEdit;

const PwEditBtn = styled.button.attrs((props) => {})`
  width: 338px;
  height: 48px;
  display: flex;
  padding: 13px 10px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  border: 1px solid #b8bfc4;
  background-color: transparent;
  color: #808991;
  font-size: 15px;
  font-weight: 600;
  line-height: 22px;
`;

const CheckboxListTitle = styled(PretendardText).attrs((props) => {})`
  color: #808991;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.039px;
  margin-bottom: 5px;
`;
